import React, { useState } from 'react';
import { usePopupFormManager } from 'features/nekst-widgets';
import {
  ButtonSize,
  OptionSelectionButton,
  SelectableOption,
} from 'ui-builder';
import { ClientPortalConfiguration } from './clientPortalConfigurationService';
import { CLIENT_APP_ACCESS_CHANGED, useClientAppAccessService } from 'nekst-api';
import { useParams } from 'react-router-dom';
import ShareClientPortalPopup from './ShareClientPortalPopup';
import { useDataLoaderNew } from 'data-loader';

interface ShareClientPortalButtonProps {
  data?: ClientPortalConfiguration;
}

export default function ShareClientPortalButton(props: ShareClientPortalButtonProps) {
  const params = useParams();
  const projectId = parseInt(params.id!, 10);

  const popupManager = usePopupFormManager();
  const clientAppAccessService = useClientAppAccessService();

  const [isCopied, setIsCopied] = useState(false);

  const { data: accessCount } = useDataLoaderNew<number>(
    async () => {
      const personIds = await clientAppAccessService.getAccessPersonIds(projectId);
      return personIds.length;
    },
    {
      dependencies: [projectId],
      events: [CLIENT_APP_ACCESS_CHANGED],
    },
  );

  const handleCopyLink = () => {
    if (props.data?._portalUrl) {
      navigator.clipboard.writeText(props.data._portalUrl);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    }
  };

  const handleOpenSharePopup = () => {
    popupManager.openForm(
      <ShareClientPortalPopup
        projectId={projectId}
        afterSubmitFunc={async () => {
          popupManager.closePopup();
        }}
      />,
      true,
    );
  };

  const options: SelectableOption<string>[] = [
    {
      label: 'Share Portal to Client App',
      value: 'share',
      onSelected: handleOpenSharePopup,
    },
    {
      label: isCopied ? 'Link Copied' : 'Copy Portal Link',
      value: 'copy',
      onSelected: handleCopyLink,
    },
  ];

  if (!props.data?.enabled || !props.data._portalUrl) {
    return null;
  }

  return (
    <OptionSelectionButton<string>
      text={`Share (${accessCount ?? 0})`}
      options={options}
      size={ButtonSize.MEDIUM}
      testId="share-client-portal-button"
    />
  );
}
